import Api from "./base/api-base";

export default class PersonEveryExcelApi {
  download (date) {
    return Api.get({
      endpoint: Api.endpoint.person_every_excel_download,
      id: date
    });
  }
}